import { render, staticRenderFns } from "./accountTT.vue?vue&type=template&id=45b13028&scoped=true"
import script from "./accountTT.vue?vue&type=script&lang=js"
export * from "./accountTT.vue?vue&type=script&lang=js"
import style0 from "./accountTT.vue?vue&type=style&index=0&id=45b13028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b13028",
  null
  
)

export default component.exports